import Joi from 'joi';
import { instagramRegex, tiktokPostRegex, youtubeRegex } from './constants';

export const logPostLinkSchema = Joi.object({
  postUrl: Joi.alternatives()
    .try(
      Joi.string().trim().required().regex(instagramRegex),
      Joi.string().trim().required().regex(tiktokPostRegex),
      Joi.string().trim().required().regex(youtubeRegex)
    )
    .messages({
      'any.required': 'URL is required',
      'string.empty': 'URL is required',
      'alternatives.match': 'Invalid Instagram / Tiktok / Youtube Post URL',
    }),
  postedDate: Joi.date().required().messages({
    'any.required': 'Posted Date is required',
  }),
});

export const logScreenshotSchema = Joi.object({
  postedDate: Joi.date().required().messages({
    'any.required': 'Posted Date is required',
  }),
});

export const ADDRESS_LINE_ONE_MIN_LENGTH = 4;
export const ADDRESS_LINE_ONE_MAX_LENGTH = 35;

export const isAddressLineOneValid = (addressLineOne = '') => {
  const { length } = addressLineOne;
  return length >= ADDRESS_LINE_ONE_MIN_LENGTH && length <= ADDRESS_LINE_ONE_MAX_LENGTH;
};

export const getAddressLineOneCharacterCountLabel = (addressLineOne = '') =>
  `${addressLineOne?.length}/${ADDRESS_LINE_ONE_MAX_LENGTH} Char.`;

export type AddressLineOneErrorMessages = {
  minLengthErrorMessage?: string;
  maxLengthErrorMessage?: string;
};

export const getAddressLineOneError = (addressLineOne = '', messages: string | AddressLineOneErrorMessages = {}) => {
  const resolvedMessages: AddressLineOneErrorMessages =
    typeof messages === 'string' ? { minLengthErrorMessage: messages } : messages;

  const {
    minLengthErrorMessage = `Address must be at least ${ADDRESS_LINE_ONE_MIN_LENGTH} characters`,
    maxLengthErrorMessage = 'Max character limit reached.',
  } = resolvedMessages;

  if (!addressLineOne) return '';
  if (addressLineOne.length >= ADDRESS_LINE_ONE_MAX_LENGTH) {
    return maxLengthErrorMessage;
  }
  if (addressLineOne.length < ADDRESS_LINE_ONE_MIN_LENGTH) {
    return minLengthErrorMessage;
  }
  return '';
};

export const handleAddressInputChange = <T extends Record<string, string>>(
  e: React.ChangeEvent<HTMLInputElement>,
  setState: React.Dispatch<React.SetStateAction<T>>,
  onPincodeChange?: (zipcode: string) => void | Promise<void>
) => {
  const { name, value } = e.target;

  if (name === 'pincode' && value !== '') {
    if (value.length <= 8) {
      setState((prev) => ({ ...prev, [name]: value }));
      if (value.length > 3) {
        onPincodeChange?.(value);
      }
    }
    return;
  }

  if (name === 'addressLineOne' && value.length > ADDRESS_LINE_ONE_MAX_LENGTH) {
    return;
  }

  setState((prev) => ({ ...prev, [name]: value }));
};
